import { useEffect, useState } from 'react';
import { mapBrowserLanguageToSupported, SupportedLocale } from 'lib/util/languageUtils';

/**
 * Hook to detect browser language and map it to supported locale
 * @param fallbackLanguage - Language to use if browser language is not supported
 * @returns The detected/mapped language or fallback
 */
export function useBrowserLanguage(fallbackLanguage: string): string {
  const [browserLanguage, setBrowserLanguage] = useState<string>(fallbackLanguage);

  useEffect(() => {
    // Skip on server-side rendering
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
      return;
    }

    const detectLanguage = (): string => {
      // Get browser language from navigator
      const navigatorLanguage = navigator.language || (navigator as any).userLanguage;

      if (!navigatorLanguage) {
        return fallbackLanguage;
      }

      // Use centralized mapping logic
      return mapBrowserLanguageToSupported(navigatorLanguage, fallbackLanguage as SupportedLocale);
    };

    setBrowserLanguage(detectLanguage());
  }, [fallbackLanguage]);

  return browserLanguage;
}
